import Login from './routes/login';
import Signup from './routes/signup';
import Default from './routes/not-found';
import ForceLogin from './routes/forcelogin';
import Index from './routes/index';

type RouteConfig = {
    component: () => JSX.Element;
    path: string;
    exact?: boolean;
};

const routes: RouteConfig[] = [
    {
        component: Default,
        path: '/404',
        exact: true,
    },
    {
        component: ForceLogin,
        path: '/:tenantId/forcelogin',
        exact: true,
    },
    {
        component: Index,
        path: '/:tenantId',
        exact: true,
    },
    {
        component: Login,
        path: '/:tenantId/login',
        exact: true,
    },
    {
        component: Signup,
        path: '/:tenantId/signup',
        exact: true,
    },
];
// Please update src/providers/application/index.tsx

export default routes;
